import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {VideoPernyataanComponent} from "./video-pernyataan.component";

const routes: Routes = [
  {
    path: 'video-pernyataan',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: VideoPernyataanComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VideoPernyataanRoutingModule { }
